import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListOutlet from "./views/listOutlet";
import CreateOutlet from "./views/createOutlet";
import ViewOutlet from "./views/viewOutlet";
import EditOutlet from "./views/editOutlet";
import "../../../style.scss";

function Brand(props) {
  const params = useParams();
  const location = useLocation();

  const title = "Manage Outlet | Chimera Solutions | Insights";
  const routes = [
    {
      name: "list",
      component: ListOutlet,
    },
    {
      name: "create",
      component: CreateOutlet,
    },
    {
      name: "view",
      component: ViewOutlet,
    },
    {
      name: "edit",
      component: EditOutlet,
    },
  ];

  let Error = props.components.setting[0].component;
  let Component = <Error />;
  let showComponent = false;

  if (params.page) {
    const route = routes.find((route) => route.name === params.page);
    showComponent = true;

    if (route) {
      const RouteComponent = route.component;
      Component = (
        <RouteComponent
          match={{ params }}
          user={props.user}
          chimeraserv={props.chimeraserv}
          components={props.components}
        />
      );
    }
  }

  const basePath = location.pathname.split("/").slice(0, 4).join("/");

  return (
    <div className="viewContainer">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div
        className="heading"
        style={{
          justifyContent: "flex-end",
          marginBottom: "10px",
          padding: "12px",
        }}
      >
        {[0, 1].includes(props.user.data.level) ? (
          <Link to={`${basePath}/create`}>
            <FontAwesomeIcon className="icon" icon={["fas", "plus"]} /> Create
            New Outlet
          </Link>
        ) : (
          <div />
        )}
        <Link to={`${basePath}/list`}>List of Outlets</Link>
      </div>
      <div className="viewBody">
        {showComponent ? (
          Component
        ) : (
          <ListOutlet
            match={{ params }}
            user={props.user}
            chimeraserv={props.chimeraserv}
            components={props.components}
          />
        )}
      </div>
    </div>
  );
}
export default Brand;
